import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import styled, { css } from 'styled-components';
import {Box, BoxButton} from '../../StyledComponents';
import { switchClient } from '../../../actions/dataAction';
import _ from 'lodash';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight';


const MainHeadingBig = styled.h1`
  text-transform: uppercase;
  margin-bottom: 20px;
  margin-top: 0;
`;

const PositioningMatrixContainer = styled.div`
  position:relative;
  display: flex;
  flex-grow: 1;
  min-height:185px;
`;

const PositioningMatrix = styled.div`
  position:absolute;
  display: flex;
  top:30px;
  bottom:20px;
  left:100px;
  right:100px;

  &:after {
    content: "";
    position: absolute;
    z-index: -1;
    background: #fff;
    height:1px;
    width:100%;
    top:50%;
  }
  &:before {
    content: "";
    position: absolute;
    z-index: -1;
    background: #fff;
    height:100%;
    width:1px;
    left:50%;
  }
`;


const AxesLabel = styled.span`
  position: absolute;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;

  ${props => props.HighX && css`
    top:calc(50% + 5px);
    right:0;
    transform:translateY(-50%);
    color: #49a184;
  `}
  ${props => props.LowX && css`
    top:calc(50% + 5px);
    left:0;
    transform:translateY(-50%);
    color: #49a184;
  `}
  ${props => props.HighY && css`
    top:0;
    left:50%;
    transform:translateX(-50%);
    color: #376176;
    margin-bottom: 10px;
  `}
  ${props => props.LowY && css`
    bottom:0;
    left:50%;
    transform:translateX(-50%);
    color: #376176;
  `}
`;


const Variable = styled.span`
  position: absolute;
  text-transform: uppercase;
  border:1px solid #fff;
  border-radius: 50px;
  padding: 3px 7px;
  font-size: 11px;
  background: #000;
  white-space: nowrap;

  ${props => props.competitor && css`
    opacity:0.5;
  `}

  &:hover {
    opacity: 1;
  }
`;

const AngleRight = styled(FontAwesomeIcon)`
  margin-left:10px;
`;

const BrandButton = styled(BoxButton)`
  margin-right:10px;
  display: inline-block;
  float: none;
  margin-bottom:5px;
`;

class PortfolioMatrix extends Component {
    renderVariables(data) {
      let output = [];



      _.forEach(data, function(brand, i) {
          const stability = brand.stability;
          const relevance = brand.relevance;
          output.push(<Variable style={{bottom:relevance+"%", left:stability+"%"}} competitor={brand.competitor}>{brand.title}</Variable>);
      });

      return output;
    }

    switchBrand(brand, previous) {
      if (brand !== previous) {
        switchClient(brand);
        this.props.history.push('/');
        window.location.reload();
      } else {
        this.props.history.push('/');
      }
    }

    testing() {
      const brandData = this.props.data.brandData || {};
      if (this.props.user && this.props.user.userProfile && this.props.user.userProfile.brands) {
        const brands = this.props.user.userProfile.brands;
        brands.forEach((brand,i) => {
          if (brandData[brand]) {
            const bData = brandData[brand];
            console.log("Brand: " + brand + " score: " + bData.rlv.score);
          }
        });
      }
    }

    brandSwitcher() {
      let brands = [];
      if (this.props.user && this.props.user.userProfile && this.props.user.userProfile.brands) {
        _.each(function(brand, i) {
          brands.push({client: brand, clientName: brand})
        });
      } else if (this.props.user && this.props.user.userProfile && this.props.user.userProfile.client) {
        //brands = [this.props.user.userProfile.clientName || this.props.user.userProfile.client];
        brands = [this.props.user.userProfile.client];
        brands = [{client: this.props.user.userProfile.client, clientName: this.props.user.userProfile.clientName || this.props.user.userProfile.client}]
      }

      return (
        <div style={{marginBottom:"25px"}}>
            {brands.map((b, i) => <BrandButton key={b} onClick={() => this.switchBrand(b.client, this.props.user.userProfile.client)}>{b.clientName}<AngleRight icon={faAngleRight} /></BrandButton>)}
        </div>
      );
    }

    getDatapoints(data) {
      let client;
      let relevanceData = {};

      if (data && data.telescope && data.telescope._data && data.telescope._data.rlv) {
        relevanceData = data.telescope._data.rlv;
      }

      if (this.props.user && this.props.user.userProfile && this.props.user.userProfile.client) {
        client = this.props.user.userProfile.clientName || this.props.user.userProfile.client;
      }

      // Calculate relevance
      //const relevance =((relevanceData.score / relevanceData.index)*100)/2; BACK
      const relevance =(relevanceData.score / relevanceData.index);
      let _relevance = 50 + relevance/100;

      if (!relevanceData.index) {
        _relevance = 50 + relevanceData.score;
      }
      const volatility = relevanceData.R2 * relevanceData.trend;
      const _volatility = 50 + (1 * volatility);

      //console.log("relevance" + " " +relevance + " " + volatility + " " + _volatility);

      return [
        {title: client, relevance: _relevance, stability: _volatility},
        {title: 'Pinewood', relevance:'10', stability:'8', competitor: true},
        {title: 'Merrell', relevance:'90', stability:'5', competitor: true},
        {title: 'Berghaus', relevance:'74', stability:'20', competitor: true},
        {title: 'Peak Performance', relevance:'60', stability:'45', competitor: true},
        {title: 'Fjällräven', relevance:'90', stability:'90', competitor: true},
        {title: 'Arceryx', relevance:'77', stability:'70', competitor: true},
        {title: 'Quechua', relevance:'65', stability:'30', competitor: true},
      ];
    }

    render() {
      const { data, propData, printBreak } = this.props;

      const placeholderData = {
        title: "Brands",
        description: "",
        variables: propData
      };

      const componentData = placeholderData;


      this.testing();

      return (
        <Box className={this.props && this.props.className + ' ' + printBreak ? 'print-page-break-after' : ''}>
            <MainHeadingBig className="big-font-size">{componentData.title}</MainHeadingBig>
            {this.brandSwitcher()}

            <MainHeadingBig className="big-font-size">Performance</MainHeadingBig>

            <PositioningMatrixContainer>

              <AxesLabel HighX>Stability</AxesLabel>
              <AxesLabel LowX></AxesLabel>
              <AxesLabel HighY>Share of voice</AxesLabel>
              <AxesLabel LowY></AxesLabel>
                <PositioningMatrix>
                  {this.renderVariables(this.getDatapoints(data))}

                  {/*
                  <MatrixLegend LowX LowY><MatrixLegendLabel>Observe</MatrixLegendLabel></MatrixLegend>
                  <MatrixLegend LowX HighY><MatrixLegendLabel>Grow</MatrixLegendLabel></MatrixLegend>
                  <MatrixLegend HighX LowY><MatrixLegendLabel>Rejuvinate</MatrixLegendLabel></MatrixLegend>
                  <MatrixLegend HighX HighY><MatrixLegendLabel>Max</MatrixLegendLabel></MatrixLegend>
                  */}

                </PositioningMatrix>
            </PositioningMatrixContainer>
        </Box>
      );

    }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        data: state.data,
        user: state.user
    };
}

export default withRouter(connect(mapStateToProps)(PortfolioMatrix));



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/PortfolioMatrix.js